export const gobeTheme = {};
